import { EUserRole } from "@/types/enum";

export const formInputs = [
  {
    inputType: "email",
    prompt: "Email address",
    name: "email",
    placeholder: "Enter email",
    fullWidth: true,
    rules: {
      isEmail: {
        expectedValue: true,
        errorMessage: "Not a valid email address",
      },
    },
  },

  {
    fullWidth: true,
    inputType: "password",
    prompt: "Password",
    name: "password",
    placeholder: "Enter password",
  },
];

export const resetPasswordInputs = [
  {
    inputType: "email",
    prompt: "Email address",
    name: "email",
    placeholder: "Enter email",
    fullWidth: true,
    rules: {
      isEmail: {
        expectedValue: true,
        errorMessage: "Not a valid email address",
      },
    },
  },
];

// MED-687: this must match new-registration/index.tsx's own handleNext
// switch (case 4 -> addressUpdate, case 5 -> pcnUpdate), not the backend's
// old (buggy) ONBOARDING_STEPS text order. pcn_licence_stage and
// address_stage were swapped here relative to that switch — a company
// resumed at "pcn_licence_stage" landed on step 4, which renders the
// address form, not PCN.
//
// final_stage maps to the same step as pcn_licence_stage rather than being
// absent: registration_routing.resume_step can be "final_stage" for a
// company whose last completed stage was pcn_licence_stage but which isn't
// marked registration_completed yet (onboarding_step is a client-asserted
// param — CompaniesController#create doesn't require the steps before it
// to have actually run). There's no step 6 to send them to; step 5 is the
// safe destination since it's the same form that stage's submission
// already goes through. Without this entry the lookup missed and `|| 1`
// silently restarted the user at step 1, losing their place entirely.
export const stageToNumber: Record<string, number> = {
  email_verification_stage: 1,
  phone_number_verification_stage: 2,
  tin_verification_stage: 3,
  address_stage: 4,
  pcn_licence_stage: 5,
  final_stage: 5,
};

export const invitedUsers = [
  EUserRole.HEAD_OF_PHARMACY,
  EUserRole.HOSPITAL_ACCOUNTANT,
  EUserRole.MINISTRY_OF_HEALTH_DG,
  EUserRole.MINISTRY_OF_HEALTH_SECRETARY,
] as const;

export type InvitedUserRole = (typeof invitedUsers)[number];

export const invitedUserDashboard: Record<InvitedUserRole, string> = {
  [EUserRole.HEAD_OF_PHARMACY]: "/dashboard/pharmacy-head/stat",
  [EUserRole.HOSPITAL_ACCOUNTANT]: "/dashboard/accountant/financials",
  [EUserRole.MINISTRY_OF_HEALTH_DG]: "/dashboard/dg-health/financials",
  [EUserRole.MINISTRY_OF_HEALTH_SECRETARY]:
    "/dashboard/state-sec/dashboard/drf",
};
